export default "__VITE_ASSET__ec1e0984__"